<template>
  <div class="role-container">
    <div class="panel-header">
      <div class="search-container">
        <div class="search-row">
          <div class="search-item">
            <label class="search-label">角色名称：</label>
            <input type="text" class="search-input" v-model="searchForm.name" placeholder="请输入角色名称"
              @keyup.enter="searchRoles" />
          </div>
          <div class="search-item">
            <label class="search-label">角色状态：</label>
            <select class="search-select" v-model="searchForm.status">
              <option value="">全部</option>
              <option value="active">启用</option>
              <option value="disabled">禁用</option>
            </select>
          </div>
          <div class="search-actions">
            <button class="btn-search" @click="searchRoles">查询</button>
            <button class="btn-reset" @click="resetSearch">重置</button>
          </div>
        </div>
      </div>
      <button class="btn-add" @click="showAddRoleModal = true">
        <span class="btn-icon">+</span>
        <span>新建角色</span>
      </button>
    </div>
    <div class="table-container">
      <table class="data-table">
        <thead>
          <tr>
            <th style="width: 60px;">序号</th>
            <th style="width: 140px;">角色名称</th>
            <th style="width: 100px;">角色状态</th>
            <th style="width: 100px;">权限数量</th>
            <th style="width: 180px;">角色描述</th>
            <th style="width: 140px;">创建时间</th>
            <th style="width: 100px;">创建人</th>
            <th style="width: 140px;">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="role in filteredRoles" :key="role.id">
            <td>{{ role.id }}</td>
            <td>{{ role.name }}</td>
            <td>{{ role.status === 'active' ? '启用' : '禁用' }}</td>
            <td>{{ role.permissions.length }}</td>
            <td>{{ role.description }}</td>
            <td>{{ role.createTime }}</td>
            <td>{{ role.creator }}</td>
            <td>
              <div class="action-buttons">
                <button class="btn-view-perm" @click="showPermissionDetail(role)">
                  <span>权限</span>
                </button>
                <button class="btn-edit" @click="editRole(role)">
                  <span>修改</span>
                </button>
                <button class="btn-delete" @click="deleteRole(role.id)">
                  <span>移除</span>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 添加/编辑角色弹窗 -->
    <div class="add-role-modal" v-if="showAddRoleModal">
      <div class="modal-overlay" @click="closeAddRoleModal"></div>
      <div class="modal-content role-modal">
        <div class="modal-header">
          <div class="modal-title">{{ editingRole ? '修改角色' : '新建角色' }}</div>
          <button class="modal-close" @click="closeAddRoleModal">
            <span>×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-row">
            <div class="form-item inline">
              <label class="form-label">角色名称：</label>
              <input type="text" class="form-input" v-model="roleForm.name" placeholder="请输入角色名称" />
            </div>
            <div class="form-item inline">
              <label class="form-label">角色状态：</label>
              <select class="form-select" v-model="roleForm.status">
                <option value="active">启用</option>
                <option value="disabled">禁用</option>
              </select>
            </div>
          </div>
          <div class="form-item inline">
            <label class="form-label">角色描述：</label>
            <textarea class="form-textarea" v-model="roleForm.description" placeholder="请输入角色描述"></textarea>
          </div>
          <div class="form-row" style="margin-top: 20px;">
            <div class="form-item inline">
              <label class="form-label">权限配置：</label>
              <div class="permission-tree-container">
                <div v-for="module in permissionTree" :key="module.id" class="tree-node">
                  <div class="tree-parent">
                    <span class="tree-icon" @click.stop="toggleModuleExpand(module)">{{ module.expanded ? '▼' : '▶'
                      }}</span>
                    <input type="checkbox" :checked="isModuleChecked(module)"
                      :indeterminate="isModuleIndeterminate(module)" @change.stop="toggleModuleCheck(module)"
                      class="parent-checkbox" />
                    <span class="tree-label">{{ module.label }}</span>
                  </div>
                  <div v-show="module.expanded" class="tree-children">
                    <div v-for="child in module.children" :key="child.id" class="tree-child">
                      <input type="checkbox" :id="'perm-' + child.id" :checked="roleForm.permissions.includes(child.id)"
                        @change="togglePermission(child.id)" />
                      <label :for="'perm-' + child.id" class="child-label">{{ child.label }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-actions">
            <button class="btn-cancel" @click="closeAddRoleModal">取消</button>
            <button class="btn-confirm" @click="saveRole">保存</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 权限详情弹窗 -->
    <div class="permission-detail-modal" v-if="showPermissionDetailModal">
      <div class="modal-overlay" @click="closePermissionDetailModal"></div>
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">{{ selectedRole && selectedRole.name }} - 权限详情</div>
          <button class="modal-close" @click="closePermissionDetailModal">
            <span>×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="detail-section">
            <div class="section-title">已授权权限</div>
            <div class="permission-list">
              <div v-for="module in permissionTree" :key="module.id" class="permission-module">
                <div class="module-header">{{ module.label }}</div>
                <div class="module-permissions">
                  <span v-for="child in module.children" :key="child.id" class="perm-tag"
                    :class="{ granted: selectedRole && selectedRole.permissions.includes(child.id) }">
                    {{ child.label }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="detail-summary">
            <div class="summary-item">
              <span class="summary-label">总权限数：</span>
              <span class="summary-value">{{ selectedRole && selectedRole.permissions ? selectedRole.permissions.length
                : 0 }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">模块数量：</span>
              <span class="summary-value">{{ getGrantedModuleCount() }}</span>
            </div>
          </div>
        </div>
        <div class="form-actions">
          <button class="btn-confirm" @click="closePermissionDetailModal">关闭</button>
        </div>
      </div>
    </div>

    <!-- 确认操作弹窗 -->
    <div class="confirm-modal" v-if="showConfirmModal">
      <div class="modal-overlay" @click="closeConfirmModal"></div>
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">确认操作</div>
          <button class="modal-close" @click="closeConfirmModal">
            <span>×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="confirm-message">{{ confirmMessage }}</div>
        </div>
        <div class="form-actions">
          <button class="btn-cancel" @click="closeConfirmModal">取消</button>
          <button class="btn-confirm btn-danger" @click="confirmAction">确定</button>
        </div>
      </div>
    </div>

    <!-- 提示弹窗 -->
    <div class="tip-modal" v-if="showTipModal">
      <div class="modal-overlay" @click="closeTipModal"></div>
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">提示</div>
          <button class="modal-close" @click="closeTipModal">
            <span>×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="tip-message">{{ tipMessage }}</div>
        </div>
        <div class="form-actions">
          <button class="btn-confirm" @click="closeTipModal">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RoleManagement',
  data() {
    return {
      showAddRoleModal: false,
      showPermissionDetailModal: false,
      selectedRole: null,
      editingRole: null,
      searchForm: {
        name: '',
        status: ''
      },
      roleForm: {
        name: '',
        description: '',
        status: 'active',
        creator: '',
        permissions: []
      },
      showConfirmModal: false,
      confirmMessage: '',
      confirmCallback: null,
      showTipModal: false,
      tipMessage: '',
      roles: [
        {
          id: 1, name: '系统管理员', description: '系统最高权限，可执行所有操作', createTime: '2026-06-09 08:00:00', creator: 'admin', status: 'active',
          permissions: ['bigdata_home_view', 'bigdata_home_edit', 'bigdata_home_export', 'data_decision_view', 'data_decision_edit', 'data_decision_export', 'price_supervision_view', 'price_supervision_edit', 'price_supervision_export', 'sentiment_monitor_view', 'sentiment_monitor_edit', 'sentiment_monitor_export', 'customer_analysis_view', 'customer_analysis_edit', 'customer_analysis_export', 'business_resource_view', 'business_resource_edit', 'business_resource_export', 'video_monitor_view', 'video_monitor_edit', 'video_monitor_export', 'capacity_monitor_view', 'capacity_monitor_edit', 'capacity_monitor_export', 'user_manage_view', 'user_manage_edit', 'user_manage_export', 'role_view', 'role_edit', 'role_export', 'log_view', 'log_edit', 'log_export']
        },
        {
          id: 2, name: '业务管理员', description: '负责业务模块管理和运维', createTime: '2026-06-09 10:30:00', creator: 'admin', status: 'active',
          permissions: ['bigdata_home_view', 'bigdata_home_edit', 'data_decision_view', 'data_decision_edit', 'data_decision_export', 'price_supervision_view', 'price_supervision_edit', 'sentiment_monitor_view', 'sentiment_monitor_edit', 'customer_analysis_view', 'customer_analysis_edit', 'business_resource_view', 'business_resource_edit', 'video_monitor_view', 'video_monitor_edit', 'capacity_monitor_view', 'capacity_monitor_edit', 'log_view', 'log_export']
        },
        {
          id: 3, name: '数据分析员', description: '可查看和导出数据分析报表', createTime: '2026-06-09 14:00:00', creator: '张伟', status: 'active',
          permissions: ['bigdata_home_view', 'data_decision_view', 'data_decision_export', 'customer_analysis_view', 'customer_analysis_export', 'sentiment_monitor_view', 'sentiment_monitor_export', 'log_view']
        },
        {
          id: 4, name: '普通访客', description: '只读访问权限', createTime: '2026-06-09 09:20:00', creator: 'admin', status: 'disabled',
          permissions: ['bigdata_home_view', 'data_decision_view', 'price_supervision_view', 'sentiment_monitor_view']
        },
        {
          id: 5, name: '数据录入员', description: '负责数据录入和维护', createTime: '2026-06-10 11:00:00', creator: '李丽', status: 'active',
          permissions: ['bigdata_home_view', 'data_decision_view', 'data_decision_edit', 'price_supervision_view', 'price_supervision_edit', 'capacity_monitor_view', 'capacity_monitor_edit']
        },
        {
          id: 6, name: '报表管理员', description: '负责报表管理和导出', createTime: '2026-06-11 15:30:00', creator: '王强', status: 'active',
          permissions: ['bigdata_home_view', 'bigdata_home_export', 'data_decision_view', 'data_decision_edit', 'data_decision_export', 'customer_analysis_view', 'customer_analysis_edit', 'customer_analysis_export', 'log_view']
        }
      ],
      permissionTree: [
        {
          id: 'bigdata_home', label: '大数据首页', expanded: false, children: [
            { id: 'bigdata_home_view', label: '查看', parent: 'bigdata_home' },
            { id: 'bigdata_home_edit', label: '编辑', parent: 'bigdata_home' },
            { id: 'bigdata_home_export', label: '导出', parent: 'bigdata_home' }
          ]
        },
        {
          id: 'data_decision', label: '数据决策中心', expanded: false, children: [
            { id: 'data_decision_view', label: '查看', parent: 'data_decision' },
            { id: 'data_decision_edit', label: '编辑', parent: 'data_decision' },
            { id: 'data_decision_export', label: '导出', parent: 'data_decision' }
          ]
        },
        {
          id: 'price_supervision', label: '价格动态监管', expanded: false, children: [
            { id: 'price_supervision_view', label: '查看', parent: 'price_supervision' },
            { id: 'price_supervision_edit', label: '编辑', parent: 'price_supervision' },
            { id: 'price_supervision_export', label: '导出', parent: 'price_supervision' }
          ]
        },
        {
          id: 'sentiment_monitor', label: '全网舆情监测', expanded: false, children: [
            { id: 'sentiment_monitor_view', label: '查看', parent: 'sentiment_monitor' },
            { id: 'sentiment_monitor_edit', label: '编辑', parent: 'sentiment_monitor' },
            { id: 'sentiment_monitor_export', label: '导出', parent: 'sentiment_monitor' }
          ]
        },
        {
          id: 'customer_analysis', label: '客群画像分析', expanded: false, children: [
            { id: 'customer_analysis_view', label: '查看', parent: 'customer_analysis' },
            { id: 'customer_analysis_edit', label: '编辑', parent: 'customer_analysis' },
            { id: 'customer_analysis_export', label: '导出', parent: 'customer_analysis' }
          ]
        },
        {
          id: 'business_resource', label: '业态资源统筹', expanded: false, children: [
            { id: 'business_resource_view', label: '查看', parent: 'business_resource' },
            { id: 'business_resource_edit', label: '编辑', parent: 'business_resource' },
            { id: 'business_resource_export', label: '导出', parent: 'business_resource' }
          ]
        },
        {
          id: 'video_monitor', label: '视频监测管理', expanded: false, children: [
            { id: 'video_monitor_view', label: '查看', parent: 'video_monitor' },
            { id: 'video_monitor_edit', label: '编辑', parent: 'video_monitor' },
            { id: 'video_monitor_export', label: '导出', parent: 'video_monitor' }
          ]
        },
        {
          id: 'capacity_monitor', label: '承载力监测', expanded: false, children: [
            { id: 'capacity_monitor_view', label: '查看', parent: 'capacity_monitor' },
            { id: 'capacity_monitor_edit', label: '编辑', parent: 'capacity_monitor' },
            { id: 'capacity_monitor_export', label: '导出', parent: 'capacity_monitor' }
          ]
        },
        {
          id: 'user_manage', label: '用户管理', expanded: false, children: [
            { id: 'user_manage_view', label: '查看', parent: 'user_manage' },
            { id: 'user_manage_edit', label: '编辑', parent: 'user_manage' },
            { id: 'user_manage_export', label: '导出', parent: 'user_manage' }
          ]
        },
        {
          id: 'role', label: '角色配置', expanded: false, children: [
            { id: 'role_view', label: '查看', parent: 'role' },
            { id: 'role_edit', label: '编辑', parent: 'role' },
            { id: 'role_export', label: '导出', parent: 'role' }
          ]
        },
        {
          id: 'log', label: '系统日志', expanded: false, children: [
            { id: 'log_view', label: '查看', parent: 'log' },
            { id: 'log_edit', label: '编辑', parent: 'log' },
            { id: 'log_export', label: '导出', parent: 'log' }
          ]
        }
      ]
    }
  },
  computed: {
    filteredRoles() {
      let result = this.roles
      if (this.searchForm.name) {
        result = result.filter(role => role.name.toLowerCase().includes(this.searchForm.name.toLowerCase()))
      }
      if (this.searchForm.status) {
        result = result.filter(role => role.status === this.searchForm.status)
      }
      return result
    }
  },
  methods: {
    searchRoles() {
      // 搜索逻辑已在 computed 中实现
    },
    resetSearch() {
      this.searchForm = {
        name: '',
        status: ''
      }
    },
    editRole(role) {
      this.editingRole = role
      this.roleForm = {
        name: role.name,
        description: role.description,
        status: role.status,
        creator: role.creator,
        permissions: JSON.parse(JSON.stringify(role.permissions))
      }
      this.showAddRoleModal = true
    },
    showPermissionDetail(role) {
      this.selectedRole = role
      this.showPermissionDetailModal = true
    },
    closePermissionDetailModal() {
      this.showPermissionDetailModal = false
      this.selectedRole = null
    },
    getGrantedModuleCount() {
      if (!this.selectedRole) return 0
      let count = 0
      this.permissionTree.forEach(module => {
        const hasPermission = module.children.some(child => this.selectedRole.permissions.includes(child.id))
        if (hasPermission) count++
      })
      return count
    },
    deleteRole(id) {
      const role = this.roles.find(r => r.id === id)
      this.showConfirmModalFn(`确定要删除角色 "${role && role.name}" 吗？`, () => {
        this.roles = this.roles.filter(r => r.id !== id)
        this.showTipMessage('删除成功')
      })
    },
    closeAddRoleModal() {
      this.showAddRoleModal = false
      this.editingRole = null
      this.roleForm = {
        name: '',
        description: '',
        status: 'active',
        creator: '',
        permissions: []
      }
      this.permissionTree.forEach(module => {
        module.expanded = false
      })
    },
    saveRole() {
      if (!this.roleForm.name.trim()) {
        this.showTipMessage('请输入角色名称')
        return
      }

      if (this.editingRole) {
        const index = this.roles.findIndex(r => r.id === this.editingRole.id)
        if (index !== -1) {
          this.roles[index] = {
            ...this.roles[index],
            name: this.roleForm.name,
            description: this.roleForm.description,
            status: this.roleForm.status,
            permissions: [...this.roleForm.permissions]
          }
        }
        this.showTipMessage('修改成功')
      } else {
        const newId = Math.max(...this.roles.map(r => r.id)) + 1
        this.roles.push({
          id: newId,
          name: this.roleForm.name,
          description: this.roleForm.description,
          status: this.roleForm.status,
          creator: 'admin',
          permissions: [...this.roleForm.permissions],
          createTime: new Date().toLocaleString('zh-CN')
        })
        this.showTipMessage('新建成功')
      }

      this.closeAddRoleModal()
    },
    togglePermission(permId) {
      const index = this.roleForm.permissions.indexOf(permId)
      if (index > -1) {
        this.roleForm.permissions.splice(index, 1)
      } else {
        this.roleForm.permissions.push(permId)
      }
    },
    toggleModuleExpand(module) {
      module.expanded = !module.expanded
    },
    toggleModuleCheck(module) {
      const childIds = module.children.map(c => c.id)
      const allChecked = childIds.every(id => this.roleForm.permissions.includes(id))

      if (allChecked) {
        childIds.forEach(id => {
          const idx = this.roleForm.permissions.indexOf(id)
          if (idx > -1) this.roleForm.permissions.splice(idx, 1)
        })
      } else {
        childIds.forEach(id => {
          if (!this.roleForm.permissions.includes(id)) {
            this.roleForm.permissions.push(id)
          }
        })
      }
    },
    isModuleChecked(module) {
      return module.children.every(child => this.roleForm.permissions.includes(child.id))
    },
    isModuleIndeterminate(module) {
      const checkedCount = module.children.filter(child => this.roleForm.permissions.includes(child.id)).length
      return checkedCount > 0 && checkedCount < module.children.length
    },
    showConfirmModalFn(message, callback) {
      this.confirmMessage = message
      this.confirmCallback = callback
      this.showConfirmModal = true
    },
    closeConfirmModal() {
      this.showConfirmModal = false
      this.confirmMessage = ''
      this.confirmCallback = null
    },
    confirmAction() {
      if (this.confirmCallback) {
        this.confirmCallback()
      }
      this.closeConfirmModal()
    },
    showTipMessage(message) {
      this.tipMessage = message
      this.showTipModal = true
    },
    closeTipModal() {
      this.showTipModal = false
      this.tipMessage = ''
    }
  }
}
</script>

<style scoped>
.role-container {
  --ui-bg: #f5f7fa;
  --ui-surface: #ffffff;
  --ui-surface-soft: #f9fafc;
  --ui-border: #dcdfe6;
  --ui-border-soft: #ebeef5;
  --ui-text: #1f2937;
  --ui-text-regular: #606266;
  --ui-primary: #409eff;
  --ui-success: #67c23a;
  --ui-danger: #f56c6c;
  --ui-radius: 8px;
  --ui-shadow: 0 8px 24px rgba(31, 45, 61, 0.08);

  min-height: calc(100vh - 54px);
  background: var(--ui-bg);
  padding: 24px;
  box-sizing: border-box;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  padding-bottom: 14px;
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-icon {
  font-size: 24px;
}

.panel-title h2 {
  margin: 0;
  color: var(--ui-text);
  font-size: 20px;
}

.search-container {
  flex: 1;
  /* background: rgba(255, 255, 255, 0.96);
  border: 1px solid var(--ui-border-soft);
  border-radius: var(--ui-radius);
  box-shadow: var(--ui-shadow);
  padding: 14px 18px; */
}

.search-row {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.search-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-label {
  color: var(--ui-text-regular);
  font-size: 13px;
}

.search-input {
  padding: 8px 12px;
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: 6px;
  color: var(--ui-text);
  font-size: 13px;
  min-width: 180px;
}

.search-select {
  padding: 8px 12px;
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: 6px;
  color: var(--ui-text);
  font-size: 13px;
}

.search-actions {
  display: flex;
  gap: 10px;
}

.btn-search,
.btn-reset {
  min-height: 32px;
  padding: 0 14px;
  border: 1px solid var(--ui-border);
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: none;
}

.btn-search {
  background: #ecf5ff;
  color: #1d4f91;
  border-color: #b3d8ff;
}

.btn-search:hover {
  background: rgba(64, 158, 255, 0.15);
}

.btn-reset {
  background: var(--ui-surface-soft);
  color: var(--ui-text-regular);
}

.btn-reset:hover {
  background: rgba(0, 0, 0, 0.05);
}

.btn-add {
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 32px;
  padding: 0 14px;
  background: #ecf5ff;
  border: 1px solid #b3d8ff;
  border-radius: 6px;
  color: #1d4f91;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: none;
}

.btn-add:hover {
  background: rgba(64, 158, 255, 0.15);
}

.btn-icon {
  font-size: 16px;
}

.table-container {
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid var(--ui-border-soft);
  border-radius: var(--ui-radius);
  box-shadow: var(--ui-shadow);
  overflow: hidden;
  padding: 18px;
  box-sizing: border-box;
}

.table-container * {
  text-shadow: none;
}

.table-container,
.table-container p,
.table-container span,
.table-container div {
  color: var(--ui-text-regular, #606266);
}

.data-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.data-table th,
.data-table td {
  min-height: 36px;
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid var(--ui-border-soft, #ebeef5);
}

.data-table tr:last-child td {
  border-bottom: 0;
}

.data-table th {
  background: var(--ui-surface-soft);
  color: var(--ui-text);
  font-weight: 600;
  font-size: 13px;
}

.data-table tbody tr:hover {
  background: #ecf5ff;
}

.data-table td {
  color: var(--ui-text);
  font-size: 13px;
}

.permission-tree-preview {
  max-width: 280px;
  background: var(--ui-surface-soft);
  border-color: var(--ui-border-soft);
  padding: 8px;
  border-radius: 6px;
}

.module-item {
  margin-bottom: 4px;
}

.module-name-small {
  font-size: 11px;
  color: var(--ui-text);
  margin-right: 8px;
}

.module-perms {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.perm-badge {
  padding: 2px 8px;
  background: rgba(96, 98, 102, 0.1);
  color: var(--ui-text-regular);
  border-radius: 10px;
  font-size: 10px;
  border: 1px solid transparent;
}

.perm-badge.active {
  background: #ecf5ff;
  color: var(--ui-primary);
  border-color: #b3d8ff;
}

.action-buttons {
  display: flex;
  gap: 6px;
}

.btn-view-perm,
.btn-edit,
.btn-delete {
  min-height: 28px;
  padding: 0 10px;
  border: 1px solid var(--ui-border);
  border-radius: 4px;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: none;
}

.btn-view-perm {
  background: #ecf5ff;
  color: var(--ui-primary);
  border-color: #b3d8ff;
}

.btn-view-perm:hover {
  background: rgba(64, 158, 255, 0.15);
}

.btn-edit {
  background: var(--ui-surface-soft);
  color: var(--ui-primary);
}

.btn-edit:hover {
  background: rgba(64, 158, 255, 0.1);
}

.btn-delete {
  background: #fef0f0;
  color: var(--ui-danger);
  border-color: #fde2e2;
}

.btn-delete:hover {
  background: rgba(245, 108, 108, 0.15);
}

/* 弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(31, 45, 61, 0.28);
  z-index: 1000;
}

.modal-content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  z-index: 1001;
  width: fit-content;
  min-width: 480px;
  max-width: 90vw;
  max-height: 90vh;
  overflow-y: auto;
  padding: 18px;
  box-sizing: border-box;
}

.modal-content.role-modal {
  min-width: 600px;
}

.modal-content * {
  text-shadow: none;
}

.modal-content,
.modal-content p,
.modal-content span,
.modal-content div {
  color: var(--ui-text-regular, #606266);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid var(--ui-border-soft);
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--ui-text);
}

.modal-close {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  color: #999;
  font-size: 24px;
  cursor: pointer;
  border-radius: 4px;
  transition: color 0.2s;
}

.modal-close:hover {
  background: rgba(0, 0, 0, 0.05);
}

.modal-body {
  padding: 20px 0;
}

.form-row {
  display: flex;
  gap: 20px;
  margin-bottom: 16px;
}

.form-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-item.inline {
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.form-item.inline .form-label {
  flex-shrink: 0;
  width: 80px;
  white-space: nowrap;
  text-align: right;
}

.form-item.inline .form-input,
.form-item.inline .form-select {
  flex: 1;
  min-width: 0;
}

.form-item.full-width {
  flex: 1;
  min-width: 100%;
}

.form-label {
  font-size: 13px;
  color: var(--ui-text-regular);
}

.form-input,
.form-select {
  padding: 10px 12px;
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: 6px;
  color: var(--ui-text);
  font-size: 14px;
}

.form-textarea {
  width: 100%;
  padding: 10px 12px;
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: 6px;
  color: var(--ui-text);
  font-size: 14px;
  min-height: 80px;
  resize: vertical;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.btn-cancel {
  min-height: 32px;
  padding: 0 14px;
  background: transparent;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-cancel:hover {
  border-color: #999;
}

.btn-confirm {
  min-height: 32px;
  padding: 0 14px;
  background: #409eff;
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-confirm:hover {
  background: #67b8ff;
}

.btn-confirm.btn-danger {
  background: #f56c6c;
  color: #fff;
}

.btn-confirm.btn-danger:hover {
  background: #f78989;
}

/* 权限树样式 */
.permission-tree-container {
  width: 100%;
  background: var(--ui-surface-soft);
  border: 1px solid var(--ui-border);
  border-radius: 8px;
  padding: 12px;
  max-height: 300px;
  overflow-y: auto;
}

.tree-node {
  margin-bottom: 4px;
}

.tree-parent {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}

.tree-parent:hover {
  background: #ecf5ff;
}

.tree-icon {
  font-size: 10px;
  color: var(--ui-text-regular);
}

.tree-label {
  color: var(--ui-text);
  font-size: 13px;
}

.parent-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.tree-children {
  padding-left: 24px;
  margin-top: 4px;
}

.tree-child {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 6px;
  border-radius: 4px;
  transition: background 0.2s;
}

.tree-child:hover {
  background: #ecf5ff;
}

.tree-child input[type="checkbox"] {
  width: 14px;
  height: 14px;
  cursor: pointer;
}

.tree-child .child-label {
  color: var(--ui-text-regular);
  font-size: 12px;
  cursor: pointer;
}

.child-label {
  color: var(--ui-text-regular);
  font-size: 12px;
}

.confirm-message,
.tip-message {
  color: var(--ui-text);
  font-size: 15px;
  text-align: center;
}

/* 权限详情弹窗样式 */
.detail-section {
  margin-bottom: 20px;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--ui-text);
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--ui-border-soft);
}

.permission-list {
  background: var(--ui-surface-soft);
  border-radius: 8px;
  padding: 12px;
}

.permission-module {
  margin-bottom: 16px;
}

.permission-module:last-child {
  margin-bottom: 0;
}

.module-header {
  font-size: 13px;
  font-weight: 500;
  color: var(--ui-text);
  margin-bottom: 8px;
  padding-left: 8px;
}

.module-permissions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding-left: 8px;
}

.perm-tag {
  padding: 4px 10px;
  background: rgba(96, 98, 102, 0.1);
  color: var(--ui-text-regular);
  border-radius: 12px;
  font-size: 12px;
  border: 1px solid transparent;
}

.perm-tag.granted {
  background: #ecf5ff;
  color: var(--ui-primary);
  border-color: #b3d8ff;
}

.detail-summary {
  display: flex;
  gap: 30px;
  padding: 12px;
  background: rgba(64, 158, 255, 0.05);
  border-radius: 8px;
}

.summary-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.summary-label {
  font-size: 13px;
  color: var(--ui-text-regular);
}

.summary-value {
  font-size: 14px;
  font-weight: 600;
  color: var(--ui-primary);
}
</style>


// WEBPACK FOOTER //
// src/pages/role.vue